import { useOutletContext, Navigate } from "react-router";
import type { SessionUser } from "../lib/session-loader";
import { OnboardingWizard } from "../components/welcome/onboarding/OnboardingWizard";

export function WelkomPage() {
  const session = useOutletContext<SessionUser>();
  // Returning users (defaultModule already set) skip onboarding entirely.
  if (session.defaultModule) {
    return <Navigate to={`/${session.defaultModule}`} replace />;
  }
  return <OnboardingWizard session={session} />;
}
